module.exports = __webpack_public_path__ + "img/logo13.0f054386.png";